/* Keep Stamped's own scroll controller clear of the theme's sticky header. */
(() => {
  if (window.pdlReviewsOffsetsBound) return;
  window.pdlReviewsOffsetsBound = true;

  const syncOffset = () => {
    const widget = document.getElementById('stamped-main-widget');
    if (!widget) return;

    const header = document.querySelector('store-header[data-is-sticky="true"]');
    const offset = String(Math.ceil(header ? header.getBoundingClientRect().height : 0) + 8);
    widget.setAttribute('data-offset', offset);
    widget.setAttribute('data-offset-mobile', offset);

    // Stamped treats "false" as no scrolling, so use its duration option instead.
    if (!widget.hasAttribute('data-pdl-review-animation')) {
      widget.setAttribute('data-pdl-review-animation', widget.getAttribute('data-animation') || 'true');
    }
    const animation = widget.getAttribute('data-pdl-review-animation');
    widget.setAttribute('data-animation', animation !== 'false'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? '1' : animation);
  };

  syncOffset();
  // Capture runs before Stamped's delegated click handler. Read the current
  // widget/header every time, including after a theme-editor section replacement.
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element
      && event.target.closest('.stamped-main-badge, #stamped-main-widget')) syncOffset();
  }, true);
  document.addEventListener('shopify:section:load', syncOffset);
})();
